$shm_hitalama_components_preview $mol_page
	definition $shm_hitalama_map_widget_entity_custom
	demo_model $shm_hitalama_components_demo
		definition <= definition
		mocked? => mocked?
	title \Просмотр
	minimal_width 320
	tools /
		<= Demo_mocked $mol_check_box
			title \Демо-заглушки
			checked? <=> mocked?
		<= Fullscreen $mol_link_iconed
			hint \Открыть приложение на весь экран
			arg <= fullscreen_arg *
			sub / <= Fullscreen_icon $mol_icon_arrow_expand_all
	body /
		<= Result $mol_view
			sub <= content /$mol_view
		<= Description $shm_hitalama_components_preview_description
			definition <= definition
